<script>
export default {
    name: "FilteredConsultantPayment",

    data() {

        return {
            payments: [],
        }
    },

    mounted() {
        this.$root.loading = true;
        Promise.allSettled([ this.fetchPayments(), ]).then(() => {
            this.$root.loading = false;
            setTimeout(() => {
                window.print();
            }, 250);
        }).catch(() => { this.$root.loading = false; });
    },

    methods: {

        fetchPayments() {
            
            let url = `Accounts/GetConsultantPaymentsPaidfiterDate`;
                url += `?Datefrom=${this.$route.query.DateFrom}&Dateto=${this.$route.query.DateTo}`;
                url+= `&ConsultantID=${this.$route.query.ConsultantID}`;

            return this.$http.get(url).then(response => {
                this.payments = response.data;
            }).catch(() => { });
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap">
        <tail-address-header></tail-address-header>
        <div class="w-full text-center my-3">
            <h5 class="font-bold text-base uppercase">Consultant Payments</h5>
        </div>
        <div class="w-full overflow-auto">
            <table class="table">
                <thead class="text-sm">
                    <tr class="w-full flex">
                        <th class="p-tiny flex-1">Payment Date</th>
                        <th class="p-tiny flex-1">Payment Ref</th>
                        <th class="p-tiny flex-1">Memo</th>
                        <th class="p-tiny flex-1">Mode</th>
                        <th class="p-tiny flex-1">Amount</th>
                        <th class="p-tiny flex-1">Paid</th>
                        <th class="p-tiny flex-1">Balance</th>
                        <th class="p-tiny flex-1">Paid By</th>
                    </tr>
                </thead>
                <tbody class="text-xs flex flex-col items-center overflow-auto">
                    <tr class="w-full flex" v-for="(payment,idx) in payments" :key="idx">
                        <td class="p-tiny flex-1">{{ payment.trxDate | dateFormat }}</td>
                        <td class="p-tiny flex-1">{{ payment.invoiceRef }}</td>
                        <td class="p-tiny flex-1">{{ payment.invoiceMemo || `-` }}</td>
                        <td class="p-tiny flex-1">{{ payment.mode }}</td>
                        <td class="p-tiny flex-1">{{ payment.amount | numberFormat }}</td>
                        <td class="p-tiny flex-1">{{ payment.paid | numberFormat }}</td>
                        <td class="p-tiny flex-1">{{ payment.balance | numberFormat }}</td>
                        <td class="p-tiny flex-1">{{ payment.paidBy }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>